import React from "react";
import styled from "@emotion/styled";
import { Box, useTheme } from "@mui/material";
import { LoadingPlaceHolder } from "@rentablo/components";
import { useListAndSearchAllAccountHolders } from "@rentablo/api/apiv1";
import { CashbackDashboardContactsItem } from "./CashbackDashboardContactsItem";

const Container = styled.div`
  width: 100%;
  display: flex;
  gap: ${({ theme }) => theme.spacing(2)};
  flex-wrap: wrap;
  ${({ theme }) => theme.breakpoints.down("md")} {
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing(3)};
  }
`;

export const CashbackDashboardContacts = () => {
  const {
    data: contacts,
    isFetching,
    isPending,
  } = useListAndSearchAllAccountHolders();
  const theme = useTheme();

  if (isFetching || isPending) {
    return (
      <Box
        mt={6}
        display="flex"
        gap={2}
        flexWrap="wrap"
        sx={{
          "& > div": {
            flexBasis: "360px",
            height: "268px",
          },

          [theme.breakpoints.down("md")]: {
            width: "100%",
            "& > div": {
              flexBasis: "268px",
            },
            flexDirection: "column",
            gap: theme.spacing(3),
          },
        }}
      >
        <LoadingPlaceHolder />
        <LoadingPlaceHolder />
        <LoadingPlaceHolder />
      </Box>
    );
  }

  return (
    <Container>
      {contacts?.accountHolders &&
        contacts.accountHolders.map((contact) => (
          <CashbackDashboardContactsItem contact={contact} key={contact.id} />
        ))}
    </Container>
  );
};
